import { Box, Text } from "@chakra-ui/react"
import Link from "@pathwright/ux/src/components/link/Link"
import { usePathwrightContext } from "../../pathwright/PathwrightContext"
import Tip, { TipProps } from "../../tips/Tip"

function HomeWelcomeMemberBlankSlateTip(props: Partial<TipProps>) {
  const { me } = usePathwrightContext()

  return (
    <Tip
      tip={{
        id: "home-welcome-member-blank-slate",
        title: `Welcome, ${me.first_name}!`,
        content: (
          <Box>
            <Text color="inherit" mt={0}>
              Your Home screen is where you can keep track of all your learning
              Paths.
            </Text>
            <Text color="inherit">
              To get started,{" "}
              <Link variant="underline" to="/library/">
                add a Path
              </Link>
              .
            </Text>
          </Box>
        )
      }}
      icon="lightbulb-on"
      layout="dismissable"
      colorPalette="dark"
      {...props}
    />
  )
}

export default HomeWelcomeMemberBlankSlateTip
